var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.33 6.25H2.08v27.083h31.25V6.25ZM33.33 16.666h8.333l6.25 6.25v10.417H33.33V16.666ZM11.458 43.75a5.208 5.208 0 1 0 0-10.417 5.208 5.208 0 0 0 0 10.417ZM38.538 43.75a5.208 5.208 0 1 0 0-10.416 5.208 5.208 0 0 0 0 10.416Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDelivery;